var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileRawtextRegular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_6",
    "data-name": "Differenzmenge 6",
    d: "M17,19H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H17a2,2,0,0,1,2,2V17A2,2,0,0,1,17,19ZM12.208,6.916V8H13.72v4.5h1.217V8h1.512V6.916ZM9.424,10.444h.024L10.656,12.5h1.408L10.248,9.636l1.72-2.721H10.656L9.552,8.8H9.528L8.44,6.916H7.024l1.7,2.7L6.936,12.5H8.248l1.176-2.056ZM2.552,6.916V8H4.064v4.5H5.28V8H6.792V6.916Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileRawtextRegular);
export default __webpack_public_path__ + "static/media/file-rawtext-regular.b33a205b38858edad94369122c0a0bd4.svg";
export { ForwardRef as ReactComponent };